/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useRef, useState } from "react";
import { YardDateField } from "../../../components/common/YardDateField";

import { useSearchableList } from "../../../dataProvider/useSearchableList";

import {
  Box,
  Card,
  Divider,
  Tab,
  Tabs,
  Toolbar,
  useMediaQuery,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";

import {
  BulkActionsToolbar,
  Datagrid,
  EditButton,
  FilterButton,
  FunctionField,
  ListContextProvider,
  RefreshButton,
  SelectInput,
  SimpleList,
  TextField,
  Title,
  TopToolbar,
  useListContext,
} from "react-admin";
import { FilterContext, FilterForm } from "ra-ui-materialui";
import { Form } from "react-final-form";

import {
  ChevronRightIcon,
  MobileIcon,
} from "../../../components/common/iconography";
import { CustomField } from "../../../components/common/CustomFields";
import { EmptyInbound } from "./EmptyInbound";
import { ForceTitle } from "../../../components/common/ForceTitle";
import { Pagination } from "../../../components/Pagination";
import { QuickFilter } from "../../../components/common/QuickFilter";
import { SearchField } from "../../../components/common/SearchField";
import { ListDatePicker } from "../../../components/common/ListDatePicker";
import ExportDropDown from "../../../components/common/ExportDropDown";
import { AccountDropDown } from "../../../components/common/AccountDropDown";
import { accountNameRenderer } from "../../../components/common/AccountNameRenderer";
import { QuickMultiFilter } from "../../../components/common/QuickMultiFilter";
import { BetaBadge } from "../../../components/common/FeatureBadges";

import { isAuthorized, isSubscriptionDisabled } from "../../../utils/appUtils";
import {
  AclType,
  CarrierType,
  CarrierTypes,
  InboundStatus,
} from "../../../utils/constants";
import {
  exceptionRenderer,
  normalizeValue,
  truncateText,
} from "../../../utils/utils";
import { getChargeRules } from "../accounts/chargeRules/ChargeRuleUtils";

import {
  BulkCreateInvoiceButton,
  CreateInvoiceButton,
} from "./CreateInvoiceButton";
import { AdvanceButton } from "./AdvanceButton";
import { InboundStateIcon } from "./InboundStateIcon";
import { inboundExportCsv, inboundExportPdf } from "./InboundExports";
import CreateMenuButton from "./CreateMenuButton";

const useStyles = makeStyles((theme) => ({
  listRoot: {
    transition: theme.transitions.create(["all"], {
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginRight: 0,
  },
  bulkActions: {
    // [classes.bulkActions] remove to restore original behavior
    marginTop: -theme.spacing(8),
    transition: theme.transitions.create("margin-top"),
  },
}));

const useToolbarStyles = makeStyles(
  (theme) => ({
    toolbar: {
      justifyContent: "space-between",
      alignItems: "flex-start",
      paddingRight: 0,
      [theme.breakpoints.up("xs")]: {
        paddingLeft: 0,
      },
      [theme.breakpoints.down("xs")]: {
        paddingLeft: theme.spacing(2),
      },
    },
    leftControlsXs: {
      [theme.breakpoints.down("xs")]: {
        width: "100%",
        paddingRight: theme.spacing(2),

        // Make FilterForm inputs span full width on mobile
        "& [class*='RaFilterForm-form']": {
          width: "100%",
        },
        "& .filter-field": {
          width: "100%",
          flexBasis: "100%",
          flexGrow: 1,
        },
        // Remove the trailing spacer that prevents full-width controls
        "& .filter-field > div:last-child": {
          display: "none",
        },
      },
    },
  }),
  { name: "InboundListToolbar" },
);

const tabs = [
  {
    id: InboundStatus.ADVICE_ALL,
    name: (
      <span>
        Advices <BetaBadge />
      </span>
    ),
    sortKey: "scheduledDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: InboundStatus.IN_TRANSIT,
    name: "In Transit",
    sortKey: "scheduledDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: InboundStatus.ARRIVED,
    name: "Notified",
    sortKey: "notifyDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: InboundStatus.PLACED,
    name: (
      <Box display="flex">
        <MobileIcon />
        PLACED
      </Box>
    ),
    sortKey: "placedDateTime",
    sortOrder: "ASC",
    showSmall: true,
  },
  {
    id: InboundStatus.RELEASED,
    name: "Released",
    sortKey: "releaseDateTime",
    sortOrder: "DESC",
    showSmall: false,
  },
];

const InboundSearchField = (props) => {
  const { label, alwaysOn } = props;
  const { displayedFilters, filterValues, setFilters } = useListContext(props);

  const handleSearch = (value) => {
    if (value) {
      const normalizedValue = normalizeValue(value);
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(
        {
          ...nextFilterValues,
          or: [
            { carrierName: { matchPhrasePrefix: `${value}` } },
            { assignedTo: { matchPhrasePrefix: `${value}` } },
            { shipFrom: { matchPhrasePrefix: `${value}` } },
            // { normalizedPoNumber: { matchPhrasePrefix: `${normalizedValue}` } },
            // { normalizedRailCarNumber: { matchPhrasePrefix: `${normalizedValue}` } },
            { normalizedPoNumber: { wildcard: `*${normalizedValue}*` } },
            { normalizedRailCarNumber: { wildcard: `*${normalizedValue}*` } },
            { lotNumber: { matchPhrasePrefix: `${value}` } },
            { lotNumber: { wildcard: `*${value}*` } },
            { customFields: { matchPhrasePrefix: `${value}` } },
            { customFields: { wildcard: `*${value}*` } },
          ],
        },
        displayedFilters,
      );
    } else {
      const nextFilterValues = { ...filterValues };
      delete nextFilterValues.or;
      setFilters(nextFilterValues, displayedFilters);
    }
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      handleSearch={handleSearch}
    />
  );
};

const getListFilters = (smDown, tabValue) => {
  const filters = [
    <InboundSearchField label="Search" tabValue={tabValue} alwaysOn />,
    <SelectInput
      source="carrierType.eq"
      label="Carrier Type"
      variant="outlined"
      resettable
      allowEmpty
      choices={CarrierTypes}
      helperText={false}
    />,
    <QuickFilter
      source="hasException"
      label="Has Exception"
      defaultValue={{ eq: true }}
    />,
    <QuickFilter source="sit" label="SIT" defaultValue={{ eq: true }} />,
  ];

  if (tabs[tabValue].id === InboundStatus.RELEASED) {
    filters.push(
      <QuickMultiFilter
        label="Not Invoiced"
        source="and"
        defaultValue={{
          or: [{ invoiceId: { eq: " " } }, { invoiceId: { exists: false } }],
          skipInvoice: { ne: true },
        }}
      />,
      <ListDatePicker
        label="Date received"
        source="endDateTime"
        filterField="endDateTime"
      />,
    );
  }
  return filters;
};

const BulkListActions = (props) => <BulkCreateInvoiceButton {...props} />;

const InboundListToolbar = (props) => {
  const {
    filters,
    actions,
    selectedAccountId,
    onAccountChange,
    onAccountsLoaded,
    xsDown,
    ...rest
  } = props;
  const classes = useToolbarStyles(props);

  return Array.isArray(filters) ? (
    <FilterContext.Provider value={filters}>
      <Toolbar className={classes.toolbar}>
        <Box
          display="flex"
          alignItems="flex-start"
          flexWrap="wrap"
          flexDirection={xsDown ? "column" : "row"}
          width={xsDown ? "100%" : undefined}
          className={xsDown ? classes.leftControlsXs : undefined}
        >
          <Form
            key={selectedAccountId || "account-all"}
            onSubmit={() => {}}
            initialValues={{ accountId: selectedAccountId || "" }}
            keepDirtyOnReinitialize
            render={() => (
              <Box
                mt={1}
                mr={xsDown ? 0 : 2}
                width={xsDown ? "100%" : undefined}
              >
                <AccountDropDown
                  source="accountId"
                  label="Account"
                  alwaysOn
                  helperText={false}
                  onAccountChange={onAccountChange}
                  onAccountsLoaded={onAccountsLoaded}
                />
              </Box>
            )}
          />
          <FilterForm />
        </Box>
        <span />
        {actions &&
          React.cloneElement(actions, {
            ...rest,
            filters, // IMPORTANT: FilterButton expects an array
            ...actions.props,
          })}
      </Toolbar>
    </FilterContext.Provider>
  ) : null;
};

const ListActions = (props) => {
  const { xsDown } = props;
  const { resource, total } = useListContext();

  return !xsDown ? (
    <TopToolbar>
      <FilterButton />
      <CreateMenuButton
        resource={resource}
        disabled={isSubscriptionDisabled()}
      />
      <ExportDropDown
        total={total}
        resource={resource}
        exporter={inboundExportCsv}
        exporterPdf={inboundExportPdf}
      />
      <RefreshButton />
    </TopToolbar>
  ) : null;
};

const getSortOrder = (tabIndex) => {
  return tabs[tabIndex].sortOrder;
};

const getSortByWithScope = (tabValue, selectedAccountId) => {
  const tabIndex = tabs.findIndex((tab) => tab.id === tabValue);
  const key = selectedAccountId
    ? "inboundShipmentByAccountByStatusByDates"
    : "inboundShipmentByReloadYardByStatusByDates";
  return `{"key":"${key}", "search":"${tabs[tabIndex].sortKey}"}`;
};

const getDefaultFilterWithScope = (tabIndex, selectedAccountId) => {
  const statusFilter = {
    beginsWith: {
      status: tabs[tabIndex].id,
    },
  };

  if (selectedAccountId) {
    return {
      accountId: selectedAccountId,
      statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime:
        statusFilter,
    };
  }

  return {
    reloadYardId: window.appUser.reloadYardId,
    statusReleaseDateTimePlacedDateTimeNotifyDateTimeScheduledDateTimeCreateDateTime:
      statusFilter,
  };
};

const getDefaultSearchFilterWithScope = (tabIndex, selectedAccountId) => {
  const tabId = tabs[tabIndex].id;
  const statusFilter =
    tabId === InboundStatus.ADVICE_ALL
      ? { matchPhrasePrefix: InboundStatus.ADVICE_ALL }
      : { eq: tabId };

  if (selectedAccountId) {
    return {
      accountId: { eq: selectedAccountId },
      status: statusFilter,
    };
  }

  return {
    reloadYardId: { eq: window.appUser?.reloadYardId },
    status: statusFilter,
  };
};

const getSessionTab = () => {
  const sessionTab = Number(sessionStorage.getItem(`InboundTab`));
  if (sessionTab && tabs[sessionTab]) {
    return sessionTab;
  }
  return 0; // Default to the first visible tab if the sessionTab is not valid
};

export const InboundList = (props) => {
  const classes = useStyles();
  const smDown = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const xsDown = useMediaQuery((theme) => theme.breakpoints.down("xs"));
  const [tabIndex, setTabIndex] = useState(getSessionTab());
  const chargeRulesPreloadKeyRef = useRef(null);
  const [, setChargeRulesCacheVersion] = useState(0);
  const reloadYardId = window.appUser?.reloadYardId;
  const accountStorageKey = `${props.resource}_${reloadYardId}_accountId`;
  const storedAccountId = localStorage.getItem(accountStorageKey);
  const [selectedAccountId, setSelectedAccountId] = useState(
    storedAccountId || null,
  );
  const [account, setAccount] = useState();

  const [defaultFilter, setDefaultFilter] = useState(() =>
    getDefaultFilterWithScope(tabIndex, selectedAccountId),
  );
  const [defaultSearchFilter, setDefaultSearchFilter] = useState(() =>
    getDefaultSearchFilterWithScope(tabIndex, selectedAccountId),
  );
  // Include key & search to display default sort order.
  const defaultSort = {
    field: getSortByWithScope(tabs[tabIndex].id, selectedAccountId),
    order: getSortOrder(tabIndex),
  };

  // memorize perPage settings
  // see useEffect [listContext?.perPage]) below
  const sessionPerPage = Number(
    localStorage.getItem(`${props.resource}_perPage`),
  );
  const [defaultPerPage, setDefaultPerPage] = useState(
    sessionPerPage ? sessionPerPage : 10,
  );

  const listContext = useSearchableList({
    ...props,
    defaultTitle: "Inbound",
    defaultFilter: defaultFilter,
    defaultSearchFilter: defaultSearchFilter,
    defaultPerPage: defaultPerPage,
    defaultSort: defaultSort,
    resource: "inboundShipments",
  });

  useEffect(() => {
    if (listContext?.perPage) {
      localStorage.setItem(`${props.resource}_perPage`, listContext.perPage);
      setDefaultPerPage(Number(listContext.perPage));
    }
  }, [listContext?.perPage]);

  useEffect(() => {
    if (listContext?.filter) {
      // reset list on automatic stale list reset
      // Extract the key query from defaultSort
      const fieldObj = JSON.parse(defaultSort.field);
      const keyToCheck = fieldObj.key;

      // Check for the key's presence in filter
      const hasKey = keyToCheck in listContext.filter;
      const hasFilterValues = Object.keys(listContext.filterValues).length > 0;
      if (hasKey && hasFilterValues) listContext.setFilters({});
    }
  }, [listContext?.filter]);

  useEffect(() => {
    if (tabs[tabIndex].id !== InboundStatus.RELEASED) {
      chargeRulesPreloadKeyRef.current = null;
      return;
    }

    const rows = (listContext?.ids || [])
      .map((id) => listContext?.data?.[id])
      .filter(Boolean);
    const accountIds = [
      ...new Set(
        rows
          // Only rail rows can hit the ON_PULL storage gate in
          // isInvoicable, so the other rows would fetch rules nothing reads.
          .filter((record) => record.carrierType === CarrierType.RAIL)
          // Effective billing account: isInvoicable reads the cache under
          // billToAccountId, so preloading the shipment's own account leaves
          // brokered rows uncached and their ON_PULL storage gate blind.
          .map((record) => record.billToAccountId || record.accountId)
          .filter(Boolean),
      ),
    ].sort();
    const preloadKey = JSON.stringify(accountIds);

    if (chargeRulesPreloadKeyRef.current === preloadKey) return;

    chargeRulesPreloadKeyRef.current = preloadKey;

    if (!accountIds.length) return;

    let isMounted = true;

    Promise.all(accountIds.map((accountId) => getChargeRules(accountId)))
      .then(() => {
        if (!isMounted) return;
        setChargeRulesCacheVersion((version) => version + 1);
      })
      .catch(() => {
        chargeRulesPreloadKeyRef.current = null;
      });

    return () => {
      isMounted = false;
    };
  }, [tabIndex, listContext?.ids, listContext?.data]);

  const applyScopedDefaults = (nextTabIndex, nextAccountId) => {
    setDefaultFilter(getDefaultFilterWithScope(nextTabIndex, nextAccountId));
    setDefaultSearchFilter(
      getDefaultSearchFilterWithScope(nextTabIndex, nextAccountId),
    );
    listContext.setSort(
      getSortByWithScope(tabs[nextTabIndex].id, nextAccountId),
      getSortOrder(nextTabIndex),
    );
    listContext.setPage(1);
    const nextFilterValues = listContext.filterValues || {};
    listContext.setFilters(
      { ...nextFilterValues },
      listContext.displayedFilters,
    );
  };

  const handleTabChange = (value) => {
    setTabIndex(value);
    applyScopedDefaults(value, selectedAccountId);
  };

  // Restore the full account object (incl. inboundCustomFields) after a
  // page reload — AccountDropDown only emits onAccountChange on user input.
  // Must be referentially stable: it is a dependency of the accounts fetch
  // effect inside AccountDropDown.
  const handleAccountsLoaded = useCallback((accounts) => {
    const restoredId = localStorage.getItem(accountStorageKey);
    if (!restoredId) return;
    setAccount(
      (prev) => prev || accounts?.find((item) => item.id === restoredId),
    );
  }, []);

  const handleAccountChange = (selectedAccount) => {
    setAccount(selectedAccount || null);
    const nextAccountId = selectedAccount?.id || null;
    setSelectedAccountId(nextAccountId);
    if (nextAccountId) {
      localStorage.setItem(accountStorageKey, nextAccountId);
    } else {
      localStorage.removeItem(accountStorageKey);
    }
    applyScopedDefaults(tabIndex, nextAccountId);
  };

  return (
    <ListContextProvider value={listContext}>
      <Title title={<ForceTitle title="Inbound" />} />
      <InboundListToolbar
        {...props}
        filters={getListFilters(smDown, tabIndex)}
        actions={<ListActions xsDown={xsDown} />}
        xsDown={xsDown}
        selectedAccountId={selectedAccountId}
        onAccountChange={handleAccountChange}
        onAccountsLoaded={handleAccountsLoaded}
      />
      <Card
        className={classnames(
          classes.listRoot,
          { [classes.bulkActions]: listContext.selectedIds.length > 0 },
          // [classes.bulkActions] remove to restore original behavior
        )}
      >
        <BulkActionsToolbar>
          <BulkListActions />
        </BulkActionsToolbar>
        <ShipmentTabs
          {...props}
          {...listContext}
          account={account}
          selectedAccountId={selectedAccountId}
          tabValue={tabIndex}
          setTabValue={handleTabChange}
          xsDown={xsDown}
          smDown={smDown}
        />
        <Pagination {...listContext} />
      </Card>
    </ListContextProvider>
  );
};

const ShipmentTabs = ({
  selectedAccountId,
  tabValue,
  setTabValue,
  setPage,
  ...props
}) => {
  const { smDown } = props;

  const handleChange = (event, value) => {
    sessionStorage.setItem("InboundTab", value);
    setTabValue(value);
  };

  return (
    <>
      <Tabs
        value={tabValue}
        indicatorColor="primary"
        textColor="primary"
        onChange={handleChange}
      >
        {tabs.map(
          (itm, idx) =>
            (!smDown || itm.showSmall) && (
              <Tab
                value={idx}
                key={itm.id}
                label={itm.name}
                id={`shipment-${idx}`}
              />
            ),
        )}
      </Tabs>
      <Divider />
      {tabs.map(
        (itm) =>
          itm.id === tabs[tabValue].id && (
            <ShipmentGrid
              {...props}
              key={itm.id}
              selectedAccountId={selectedAccountId}
              tabValue={itm.id}
            />
          ),
      )}
    </>
  );
};

const ShipmentGrid = ({
  ids,
  page,
  account,
  selectedAccountId,
  tabValue,
  ...props
}) => {
  const { xsDown, smDown } = props;
  // Only show the account's custom field columns when an account filter is
  // applied; inbound shipments store values from inboundCustomFields
  const accountFields =
    account?.inboundCustomFields?.length > 0 ? account.inboundCustomFields : [];
  const customGridFields = accountFields.map((field, index) => (
    <CustomField
      key={field.id}
      source={`customFields[${index}]`}
      field={field}
      label={field.name}
      sortable={false}
    />
  ));

  if (
    (tabValue === InboundStatus.IN_TRANSIT ||
      tabValue === InboundStatus.ADVICE_ALL) &&
    ids.length === 0 &&
    page === 1
  )
    return <EmptyInbound {...props} message="Create a new inbound" />;
  else
    return xsDown ? (
      <SimpleList
        primaryText={(record) =>
          record.account?.displayName ?? record.accountName
        }
        secondaryText={(record) => `Car/Trl No:: ${record.railCarNumber}`}
        tertiaryText={(record) =>
          record.assignedTo ? truncateText(record.assignedTo, 12) : null
        }
        leftIcon={(record) => <InboundStateIcon record={record} />}
        rightIcon={() => (
          <ChevronRightIcon
            fontSize="large"
            color="secondary"
            style={{ marginLeft: 40, marginTop: 10 }}
          />
        )}
        linkType="edit"
      />
    ) : smDown ? (
      <Datagrid rowClick="edit">
        {tabValue.startsWith(InboundStatus.ADVICE_ALL) ||
        tabValue === InboundStatus.PLACED ||
        tabValue === InboundStatus.RELEASED ? (
          <InboundStateIcon />
        ) : null}
        {tabValue === InboundStatus.PLACED ||
        tabValue === InboundStatus.RELEASED ? (
          <FunctionField
            source="hasException"
            label=" "
            render={exceptionRenderer}
          />
        ) : null}
        <FunctionField
          source="accountName"
          label="Account"
          sortable
          render={accountNameRenderer}
        />
        {tabValue === InboundStatus.IN_TRANSIT ? (
          <YardDateField
            source="scheduledDateTime"
            label="Scheduled Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === InboundStatus.ARRIVED ? (
          <YardDateField
            source="notifyDateTime"
            label="Notify Date"
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === InboundStatus.PLACED ? (
          <YardDateField
            source="placedDateTime"
            label="Placed Date"
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === InboundStatus.RELEASED ? (
          <YardDateField
            source="releaseDateTime"
            label="Release Date"
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        <TextField source="railCarNumber" label="Car/Trl No" sortable />
        <TextField source="poNumber" label="PO Number" sortable={true} />
        <TextField source="lotNumber" label="Lot Number" sortable={true} />
        {tabValue === InboundStatus.PLACED ? (
          <TextField source="assignedTo" label="Assigned To" sortable={true} />
        ) : null}
        {customGridFields}
      </Datagrid>
    ) : (
      <Datagrid
        rowClick="edit"
        hasBulkActions={
          tabValue === InboundStatus.RELEASED && isAuthorized(AclType.INVOICES)
        }
      >
        {tabValue.startsWith(InboundStatus.ADVICE_ALL) ||
        tabValue === InboundStatus.PLACED ||
        tabValue === InboundStatus.RELEASED ? (
          <InboundStateIcon />
        ) : null}

        {tabValue === InboundStatus.PLACED ||
        tabValue === InboundStatus.RELEASED ? (
          <FunctionField
            source="hasException"
            label=" "
            render={exceptionRenderer}
          />
        ) : null}
        <FunctionField
          source="accountName"
          label="Account"
          sortable
          render={accountNameRenderer}
        />
        {tabValue === InboundStatus.IN_TRANSIT ? (
          <YardDateField
            source="scheduledDateTime"
            label="Scheduled Time"
            showTime={true}
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === InboundStatus.ARRIVED ? (
          <YardDateField
            source="notifyDateTime"
            label="Notify Date"
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === InboundStatus.PLACED ? (
          <YardDateField
            source="placedDateTime"
            label="Placed Date"
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        {tabValue === InboundStatus.RELEASED ? (
          <YardDateField
            source="releaseDateTime"
            label="Release Date"
            sortable
            sortBy={getSortByWithScope(tabValue, selectedAccountId)}
          />
        ) : null}
        <TextField source="railCarNumber" label="Car/Trl No" sortable />
        <TextField source="poNumber" label="PO Number" sortable />
        <TextField source="lotNumber" label="Lot Number" sortable />
        {tabValue === InboundStatus.PLACED ? (
          <TextField source="assignedTo" label="Assigned To" sortable />
        ) : null}
        {customGridFields}

        {tabValue === InboundStatus.RELEASED ? (
          <CreateInvoiceButton {...props} />
        ) : null}
        {tabValue === InboundStatus.IN_TRANSIT ? (
          <AdvanceButton
            record={props}
            newStatus={InboundStatus.ARRIVED}
            buttonLabel="Set Notified"
            {...props}
          />
        ) : null}
        {tabValue === InboundStatus.IN_TRANSIT ||
        tabValue === InboundStatus.ARRIVED ? (
          <AdvanceButton
            record={props}
            newStatus={InboundStatus.PLACED}
            buttonLabel="Set Placed"
            {...props}
          />
        ) : null}
        {tabValue === InboundStatus.PLACED ? (
          <AdvanceButton
            record={props}
            newStatus={InboundStatus.RELEASED}
            buttonLabel="Set Released"
            {...props}
          />
        ) : null}
        <EditButton />
      </Datagrid>
    );
};
